import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EVERY_PLAN } from "../../data/pricingContent";

export function EveryPlanIncludesSection({
    title = "Every plan includes",
    description = "Core platform capabilities from day one — across all nine modules and six departments.",
    items = EVERY_PLAN,
    pricingLink,
    testId = "every-plan-includes-section",
    className = "",
}) {
    return (
        <section
            className={`relative py-16 lg:py-20 border-t border-white/[0.06] ${className}`}
            data-testid={testId}
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <p className="font-code text-xs uppercase tracking-[0.25em] text-electric font-semibold mb-3">
                        // platform included
                    </p>
                    <h2 className="font-outfit text-3xl sm:text-4xl font-bold tracking-tight text-white">
                        {title}
                    </h2>
                    <p className="mt-3 text-sm text-zinc-500 font-light leading-relaxed">
                        {description}
                    </p>
                    {pricingLink && (
                        <Link
                            to={pricingLink}
                            className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-electric hover:text-white transition"
                        >
                            View plans & pricing
                            <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    )}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.06]">
                    {items.map((p, i) => (
                        <motion.div
                            key={p.t}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-30px" }}
                            transition={{ duration: 0.35, delay: i * 0.04 }}
                            className="bg-obsidian-200 p-7 hover:bg-obsidian-100 transition-colors"
                        >
                            <p.icon className="w-5 h-5 text-electric mb-4" />
                            <h3 className="font-outfit text-base font-semibold text-white">
                                {p.t}
                            </h3>
                            <p className="text-sm text-zinc-400 mt-1.5 leading-relaxed font-light">
                                {p.d}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
